// Sign-in and profile screens.
export const authEn = {
  'auth.login.title': 'Sign In',
  'auth.login.subtitle': 'Use the account your administrator created for you.',
  'auth.login.subtitleCentral': 'Use your Digimasi account: the same sign-in as admin.digimasi.com.',
  'auth.login.email': 'Email',
  'auth.login.password': 'Password',
  'auth.login.submit': 'Sign in',
  'auth.login.submitting': 'Signing in…',
  'auth.login.captchaHint': 'Complete the check above to sign in.',
  'auth.sso.signingIn': 'Signing you in…',
  'auth.sso.failedTitle': 'Could not sign in',
  'auth.sso.invalid': 'This sign-in link is invalid or has expired.',
  'auth.sso.toLogin': 'Go to sign in',
  'auth.central.invalid': 'This sign-in has expired or was already used. Sign in again.',
  'auth.profile.title': 'Profile',
  'auth.profile.breadcrumbDashboard': 'Dashboard',
  'auth.profile.changePassword': 'Change Password',
  'auth.profile.changePasswordHint': 'Changing your password signs out every other session.',
  'auth.profile.current': 'Current password',
  'auth.profile.new': 'New password',
  'auth.profile.newHint': 'At least {min} characters',
  'auth.profile.confirm': 'Confirm new password',
  'auth.profile.mismatch': 'Passwords do not match',
  'auth.profile.submit': 'Change password',
  'auth.profile.changed': 'Password changed. Other sessions were signed out.',
  'auth.2fa.codeTitle': 'Two-step verification',
  'auth.2fa.codeSubtitle': 'Enter the 6-digit code from your authenticator app.',
  'auth.2fa.code': 'Code',
  'auth.2fa.codeHint': 'Lost your phone? Enter one of your recovery codes instead.',
  'auth.2fa.verify': 'Verify',
  'auth.2fa.verifying': 'Checking…',
  'auth.2fa.wrongCode': 'Wrong code. Try again.',
  'auth.2fa.expired': 'This sign-in has expired. Sign in again.',
  'auth.2fa.locked': 'Too many attempts. Try again in 15 minutes.',
  'auth.2fa.startOver': 'Start over',
  'auth.2fa.setupTitle': 'Set up two-step verification',
  'auth.2fa.setupRequired': 'Your account needs a code from your phone at every sign-in. Set it up now to continue.',
  'auth.2fa.setupIntro': 'Scan this QR code with an authenticator app (for example Google Authenticator, Microsoft Authenticator or 1Password), then enter the 6-digit code it shows.',
  'auth.2fa.qr': 'QR code for your authenticator app',
  'auth.2fa.manualKey': 'Can’t scan? Enter this key in the app:',
  'auth.2fa.turnOn': 'Turn on',
  'auth.2fa.working': 'Saving…',
  'auth.2fa.recoveryTitle': 'Save your recovery codes',
  'auth.2fa.recoveryIntro': 'If you lose your phone, each code signs you in once. They are shown only now: copy or download them and keep them somewhere safe.',
  'auth.2fa.copy': 'Copy',
  'auth.2fa.copied': 'Copied',
  'auth.2fa.download': 'Download',
  'auth.2fa.saved': 'I saved them, continue',
  'auth.2fa.panelTitle': 'Two-step verification',
  'auth.2fa.panelHint': 'A code from your phone at every sign-in, on top of your password.',
  'auth.2fa.panelHintCentral': 'A code from your phone at every sign-in, on top of your password. It is part of your Digimasi account, so it works for every Digimasi website you manage.',
  'auth.2fa.statusOn': 'On · {count} recovery codes left',
  'auth.2fa.statusOff': 'Off',
  'auth.2fa.statusRequired': 'Required for administrators.',
  'auth.2fa.setUp': 'Set up',
  'auth.2fa.turnOff': 'Turn off',
  'auth.2fa.turnOffHint': 'Enter a current code or a recovery code to turn it off. Moving to a new phone? Turn it off, then set it up again.',
  'auth.2fa.turnedOn': 'Two-step verification is on.',
  'auth.2fa.turnedOff': 'Two-step verification is off.',
  'auth.2fa.cancel': 'Cancel',
  'auth.2fa.banner': 'Two-step verification will soon be required for administrators. Set it up now: it takes a minute.',
  'auth.2fa.bannerAction': 'Set it up',
} as const

export const authId: Record<keyof typeof authEn, string> = {
  'auth.login.title': 'Masuk',
  'auth.login.subtitle': 'Gunakan akun yang dibuat oleh administrator Anda.',
  'auth.login.subtitleCentral': 'Pakai akun Digimasi Anda, sama dengan akun di admin.digimasi.com.',
  'auth.login.email': 'Email',
  'auth.login.password': 'Kata sandi',
  'auth.login.submit': 'Masuk',
  'auth.login.submitting': 'Sedang masuk…',
  'auth.login.captchaHint': 'Selesaikan cek di atas untuk masuk.',
  'auth.sso.signingIn': 'Sedang memasukkan Anda…',
  'auth.sso.failedTitle': 'Tidak dapat masuk',
  'auth.sso.invalid': 'Tautan masuk ini tidak valid atau sudah kedaluwarsa.',
  'auth.sso.toLogin': 'Ke halaman masuk',
  'auth.central.invalid': 'Proses masuk ini sudah kedaluwarsa atau sudah dipakai. Silakan masuk lagi.',
  'auth.profile.title': 'Profil',
  'auth.profile.breadcrumbDashboard': 'Dasbor',
  'auth.profile.changePassword': 'Ubah Kata Sandi',
  'auth.profile.changePasswordHint': 'Mengubah kata sandi akan mengeluarkan semua sesi lainnya.',
  'auth.profile.current': 'Kata sandi saat ini',
  'auth.profile.new': 'Kata sandi baru',
  'auth.profile.newHint': 'Minimal {min} karakter',
  'auth.profile.confirm': 'Konfirmasi kata sandi baru',
  'auth.profile.mismatch': 'Kata sandi tidak cocok',
  'auth.profile.submit': 'Ubah kata sandi',
  'auth.profile.changed': 'Kata sandi diubah. Sesi lainnya telah dikeluarkan.',
  'auth.2fa.codeTitle': 'Verifikasi dua langkah',
  'auth.2fa.codeSubtitle': 'Masukkan kode 6 digit dari aplikasi autentikator Anda.',
  'auth.2fa.code': 'Kode',
  'auth.2fa.codeHint': 'HP hilang? Masukkan salah satu kode pemulihan Anda.',
  'auth.2fa.verify': 'Verifikasi',
  'auth.2fa.verifying': 'Mengecek…',
  'auth.2fa.wrongCode': 'Kode salah. Coba lagi.',
  'auth.2fa.expired': 'Proses masuk ini sudah kedaluwarsa. Silakan masuk lagi.',
  'auth.2fa.locked': 'Terlalu banyak percobaan. Coba lagi dalam 15 menit.',
  'auth.2fa.startOver': 'Ulangi dari awal',
  'auth.2fa.setupTitle': 'Aktifkan verifikasi dua langkah',
  'auth.2fa.setupRequired': 'Akun Anda perlu kode dari HP setiap kali masuk. Aktifkan sekarang untuk lanjut.',
  'auth.2fa.setupIntro': 'Pindai kode QR ini dengan aplikasi autentikator (misalnya Google Authenticator, Microsoft Authenticator, atau 1Password), lalu masukkan kode 6 digit yang muncul.',
  'auth.2fa.qr': 'Kode QR untuk aplikasi autentikator Anda',
  'auth.2fa.manualKey': 'Tidak bisa memindai? Masukkan kunci ini di aplikasi:',
  'auth.2fa.turnOn': 'Aktifkan',
  'auth.2fa.working': 'Menyimpan…',
  'auth.2fa.recoveryTitle': 'Simpan kode pemulihan Anda',
  'auth.2fa.recoveryIntro': 'Kalau HP Anda hilang, setiap kode bisa dipakai sekali untuk masuk. Kode hanya ditampilkan sekarang: salin atau unduh, lalu simpan di tempat yang aman.',
  'auth.2fa.copy': 'Salin',
  'auth.2fa.copied': 'Tersalin',
  'auth.2fa.download': 'Unduh',
  'auth.2fa.saved': 'Sudah saya simpan, lanjut',
  'auth.2fa.panelTitle': 'Verifikasi dua langkah',
  'auth.2fa.panelHint': 'Kode dari HP setiap kali masuk, selain kata sandi.',
  'auth.2fa.panelHintCentral': 'Kode dari HP setiap kali masuk, selain kata sandi. Ini bagian dari akun Digimasi Anda, jadi berlaku untuk semua website Digimasi yang Anda kelola.',
  'auth.2fa.statusOn': 'Aktif · sisa {count} kode pemulihan',
  'auth.2fa.statusOff': 'Nonaktif',
  'auth.2fa.statusRequired': 'Wajib untuk admin.',
  'auth.2fa.setUp': 'Aktifkan',
  'auth.2fa.turnOff': 'Matikan',
  'auth.2fa.turnOffHint': 'Masukkan kode saat ini atau kode pemulihan untuk mematikannya. Mau pindah ke HP baru? Matikan dulu, lalu aktifkan lagi.',
  'auth.2fa.turnedOn': 'Verifikasi dua langkah sudah aktif.',
  'auth.2fa.turnedOff': 'Verifikasi dua langkah sudah dimatikan.',
  'auth.2fa.cancel': 'Batal',
  'auth.2fa.banner': 'Verifikasi dua langkah segera wajib untuk admin. Aktifkan sekarang, cuma butuh semenit.',
  'auth.2fa.bannerAction': 'Aktifkan',
}
